import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import { setToken } from "../slices/authSlice";

/* STEP 1 */
export const registerUser = createAsyncThunk(
  "register/email",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/register", payload);

      if (!res.data.success) {
        // 👈 IMPORTANT
        return rejectWithValue(res.data.message);
      }

      //   console.log("The register data is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);

/* STEP 2 */
export const verifyOtp = createAsyncThunk(
  "register/verifyOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/otp-verification", payload);
      // console.log("The data responded for otp verify is :", res.data);
      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "OTP verification failed"
      );
    }
  }
);

export const resendOtp = createAsyncThunk(
  "register/resendOtp",
  async (payload) => {
    const res = await axiosInstance.post("/resend-otp", payload);
    // console.log("The resend otp data is :", res.data);
    if (!res.data.success) {
      return rejectWithValue(res.data.message);
    }
    return res.data;
  }
);

/* STEP 3 */
export const setPassword = createAsyncThunk(
  "register/setPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/set-password", payload);
      // console.log("The data setpassword is :", res.data);
      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err.res.data);
    }
  }
);
export const getAvtar = createAsyncThunk(
  "register/getAvtar",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-avatar");
      //   console.log("The getting avtar data is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getCountry = createAsyncThunk(
  "register/getCountry",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-country");
        // console.log("The getting country data is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

/* FINAL */
export const setupProfile = createAsyncThunk(
  "register/setupProfile",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/user-profile-set", payload);
      // console.log("Thr res is :", res.data);
      const token = res.data?.data?.userAccessToken;
      const user = res.data?.data?.user_id;
      if (token) {
        dispatch(
          setToken({
            userAccessToken: token,
            user_id: user,
          })
        );

        // optional but recommended
        localStorage.setItem("9zIBz91iaMa33UPXalZiOH7mnILWM1af", token);
        // console.log("The token is :", token);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const uploadPhoto = createAsyncThunk(
  "register/uploadPhoto",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/upload-single-image", payload);
      // console.log("The data response for the  profile upload is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
